import React from "react";
const FilterIcon = () =>
  (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.775" height="24.775" viewBox="0 0 24.775 24.775"><path d="M22.969,0H1.806A1.808,1.808,0,0,0,0,1.806V4.2A1.818,1.818,0,0,0,.585,5.528l8.286,7.59a1.285,1.285,0,0,1,.419.951V24a.774.774,0,0,0,1.2.644l4.186-2.79a1.8,1.8,0,0,0,.8-1.5V14.07a1.289,1.289,0,0,1,.419-.952L24.19,5.526A1.81,1.81,0,0,0,24.775,4.2V1.806A1.808,1.808,0,0,0,22.969,0Zm0,0" transform="translate(0 0.001)"/></svg>
  );
export default FilterIcon;